
import { PropType } from "vue";

// 导出截图专用组件：与日常列表完全分离，默认渲染全部班级行、无展开按钮、无虚拟滚动
const GRADE_COLUMNS_PER_ROW = 6;
const MAX_EXPORT_SCHOOL_COUNT = 5;

interface ClassItem {
    name: string;
    course_person_count: number;
}

interface Grade {
    name: string;
    list: ClassItem[];
}

interface School {
    school_id: number;
    school_name?: string;
    name?: string;
    course_person_count: number;
    grade_count: number;
    class_count: number;
    list: Grade[];
}

interface Overview {
    personCount: number;
    schoolCount: number;
    classCount: number;
}

interface DisplayData {
    title: string;
    statistics_time: string;
    school_list: School[];
}

export default {
    props: {
        displayData: { type: Object as PropType<DisplayData>, required: true },
        selectedSchools: { type: Array as PropType<School[]>, required: true },
        overview: { type: Object as PropType<Overview>, required: true },
    },
    setup() {
        const gradeOrder = (name: string) => {
            const match = name.match(/\d+|[一二三四五六七八九十]+/);
            if (!match) return Infinity;
            const chineseNumbers = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"];
            const number = Number(match[0]) || chineseNumbers.indexOf(match[0]) + 1;
            const offset = name.startsWith("初") ? 6 : name.startsWith("高") ? 9 : 0;
            return number ? number + offset : Infinity;
        };
        const chunkGrades = (gradeList: Grade[]) => {
            const chunks: Grade[][] = [];
            const list = [...(gradeList || [])].sort((a, b) => gradeOrder(a.name) - gradeOrder(b.name));
            for (let i = 0; i < list.length; i += GRADE_COLUMNS_PER_ROW) {
                chunks.push(list.slice(i, i + GRADE_COLUMNS_PER_ROW));
            }
            return chunks.length ? chunks : [[]];
        };
        const classRows = (chunk: Grade[]) => {
            const names = new Set<string>();
            (chunk || []).forEach((grade: Grade) => {
                (grade.list || [])
                    .filter((cls: ClassItem) => cls.name !== "合计")
                    .forEach((cls: ClassItem) => names.add(cls.name));
            });
            // 与日常列表保持一致的排序：全局按班级号从小到大（不按年级分组，跨年级相同班级号去重）
            return Array.from(names).sort((a: string, b: string) =>
                a.localeCompare(b, "zh-Hans-CN", { numeric: true })
            );
        };
        const cellValue = (grade: Grade, rowName: string) => {
            const cls = (grade.list || []).find((c: ClassItem) => c.name === rowName);
            return cls ? cls.course_person_count : "-";
        };
        return {
            MAX_EXPORT_SCHOOL_COUNT,
            chunkGrades,
            classRows,
            cellValue,
        };
    },
};
